import { ColorTheme, Theme, UserSetting } from './setting.def.ts'
import { createSlice } from '@reduxjs/toolkit'
import { RootState } from '../../redux/store.ts'
import darkColors from '../../styles/dark-colors.module.scss'
import lightColors from '../../styles/light-colors.module.scss'
import darkColors1ppon from '../../styles/1ppon/ippon-dark-colors.module.scss'
import lightColors1ppon from '../../styles/1ppon/ippon-light-colors.module.scss'
import {
  blue,
  gold,
  gray,
  green,
  presetDarkPalettes,
  red,
} from '@ant-design/colors'
import theme from 'antd/es/theme/index'
import { isIppon } from '../../utils/helpers.ts'

const mergeWithAntdPalette = (
  customColors: Record<string, string>,
  palette: string[],
  prefix: string
) => {
  const merged: Record<string, string> = {}
  for (let i = 1; i <= 10; i++) {
    const key = `${prefix}${i}`
    merged[key] = customColors[key] ?? palette[i - 1]
  }
  return merged
}

const initializeThemeStyle = () => {
  const isDark =
    document.documentElement.getAttribute('data-theme') === Theme.Dark
  const baseColors = isDark ? darkColors : lightColors

  // Get Ant Design's default tokens based on current theme
  const defaultToken = isDark
    ? theme.darkAlgorithm(theme.defaultSeed)
    : theme.defaultAlgorithm(theme.defaultSeed)

  // Use the appropriate palette based on theme
  const goldPalette = isDark ? presetDarkPalettes.gold : gold
  const bluePalette = isDark ? presetDarkPalettes.blue : blue
  const redPalette = isDark ? presetDarkPalettes.red : red
  const greenPalette = isDark ? presetDarkPalettes.green : green
  const grayPalette = isDark ? presetDarkPalettes.grey : gray

  return {
    // These are colors that we define in our custom styles
    ...baseColors,

    // Merging with Ant Design's color palettes
    ...mergeWithAntdPalette(baseColors, goldPalette, 'gold'),
    ...mergeWithAntdPalette(baseColors, bluePalette, 'blue'),
    ...mergeWithAntdPalette(baseColors, redPalette, 'red'),
    ...mergeWithAntdPalette(baseColors, greenPalette, 'green'),
    ...mergeWithAntdPalette(baseColors, grayPalette, 'gray'),

    // Merging with Ant Design's default tokens
    //colorPrimaryText: defaultToken.colorPrimaryText,
    colorText: defaultToken.colorText,

    colorFill: defaultToken.colorFill,
    colorFillSecondary: defaultToken.colorFillSecondary,
    colorFillTertiary: defaultToken.colorFillTertiary,
    colorFillQuaternary: defaultToken.colorFillQuaternary,

    defaultBorderColor: defaultToken.colorBorder,

    //defaultBorderColor: defaultToken.
  }
}

const initialize1pponThemeStyle = () => {
  const isDark =
    document.documentElement.getAttribute('data-theme') === Theme.Dark
  const baseColors = isDark ? darkColors1ppon : lightColors1ppon

  // Get Ant Design's default tokens based on current theme
  const defaultToken = isDark
    ? theme.darkAlgorithm(theme.defaultSeed)
    : theme.defaultAlgorithm(theme.defaultSeed)

  // Use the appropriate palette based on theme
  const goldPalette = isDark ? presetDarkPalettes.gold : gold
  const bluePalette = isDark ? presetDarkPalettes.blue : blue
  const redPalette = isDark ? presetDarkPalettes.red : red
  const greenPalette = isDark ? presetDarkPalettes.green : green
  const grayPalette = isDark ? presetDarkPalettes.grey : gray

  return {
    // These are colors that we define in our custom styles
    ...baseColors,

    // Merging with Ant Design's color palettes
    ...mergeWithAntdPalette(baseColors, goldPalette, 'gold'),
    ...mergeWithAntdPalette(baseColors, bluePalette, 'blue'),
    ...mergeWithAntdPalette(baseColors, redPalette, 'red'),
    ...mergeWithAntdPalette(baseColors, greenPalette, 'green'),
    ...mergeWithAntdPalette(baseColors, grayPalette, 'gray'),

    // Merging with Ant Design's default tokens
    //colorPrimaryText: defaultToken.colorPrimaryText,
    colorText: defaultToken.colorText,

    colorFill: defaultToken.colorFill,
    colorFillSecondary: defaultToken.colorFillSecondary,
    colorFillTertiary: defaultToken.colorFillTertiary,
    colorFillQuaternary: defaultToken.colorFillQuaternary,

    defaultBorderColor: defaultToken.colorBorder,

    //defaultBorderColor: defaultToken.
  }
}

const initialState: UserSetting = {
  theme: Theme.Light,
}

const settingSlice = createSlice({
  name: 'setting',
  initialState,
  reducers: {
    toggleTheme: (state) => {
      document.documentElement.setAttribute(
        'data-theme',
        state.theme === Theme.Dark ? Theme.Light : Theme.Dark
      )
      state.theme = state.theme === Theme.Dark ? Theme.Light : Theme.Dark
      reloadThemeStyle()
    },
  },
})

export const { toggleTheme } = settingSlice.actions

export const selectTheme = (state: RootState): Theme => state.setting.theme!

//let _themeStyle: Partial<ColorTheme> = initializeThemeStyle()
let _themeStyle: Partial<ColorTheme> = isIppon
  ? initialize1pponThemeStyle()
  : initializeThemeStyle()

// Initialize colors after DOM is loaded
//export const reloadThemeStyle = () => {
//  _themeStyle = initializeThemeStyle()
//}
export const reloadThemeStyle = () => {
  _themeStyle = isIppon ? initialize1pponThemeStyle() : initializeThemeStyle()
}

export const selectThemeStyle = () => _themeStyle

export default settingSlice
